import { ReactElement, useState, useContext } from 'react';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, TextInput, Modal, Button } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { tile } from '@interfaces/interfaces';
import { iReviewFormValues } from '@services/ReviewService';
import VicFinesContext from '@pages/forms/VicFinesFormContext';

// import emailNotif from '../../../../images/emailviewv2.png';
// import mobileNotif from '../../../../images/mobileview.png';
import styles from './ReviewStep4.module.scss';

function ReviewStep4(): ReactElement {
  // what-will-my-notifcations-look-like-modal
  const { values }: { values: iReviewFormValues } = useFormikContext();
  const { tooltips } = useContext(VicFinesContext);
  const validTitle = Object.keys(tooltips).filter((v) => v.includes('whatwillmynotifcationslooklikemodal'));
  const modalContent = tooltips[validTitle[0]];
  const titleText = validTitle[0] ? validTitle[0].substring(validTitle[0].indexOf('|'), validTitle[0].length).replaceAll('|', ' ') : 'What will my notifications look like?';
  const [isNotifyHelp, setNotifyHelp] = useState(false);
  const closeNotifications = () => {
     setNotifyHelp(false);
  };

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];

  const TILE_DATA_NOTIFICATION_TYPE: tile[] = [
    {
      body: 'No thanks',
      value: 'none',
    },
    {
      body: 'To my mobile',
      value: 'mobile',
    },
    {
      body: 'To my email',
      value: 'email',
    },
    {
      body: 'To both',
      value: 'both',
    },
  ];
  // const notificationInformation = (): ReactElement => (
  //   <div style={{ width: '100%' }}>
  //     <div className={styles.bitmapSection}>
  //       <span className={styles.bitmapTitle}>Email notification</span>
  //       <span className={styles.bitmapTitle}>Mobile notification</span>
  //       <div className={styles.bitmapImage}>
  //         <img className={styles.image} src={emailNotif} alt="email notification view" />
  //       </div>
  //       <div className={styles.bitmapImage}>
  //         <img className={styles.image} src={mobileNotif} alt="mobile notification view" />
  //       </div>
  //     </div>
  //   </div>
  // );
  const notificationInformation = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: modalContent }} />
  );

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">Save this form?</span>
      <div className={gridStyles.gridColFull}>
        <div className="subHeadingH3"> If you select Yes, we will save the form as you fill it in, so you can close it and come back later.</div>
      </div>
      <div className={gridStyles.gridColFull}>
        <div className={styles.col}>
          <Field name="SaveYesNo" component={TileRadioAccessible} tileData={TILE_DATA} orientationRow />
        </div>
      </div>
      {values.SaveYesNo === 'true' && (
        <>
          <p>Your form content will be saved securely for up to 7 days or until submitted.</p>
          <strong>How do I access my saved form later?</strong>
          <p>
            To access saved forms visit this site, click ‘Your Fines’ and log in using the fine’s obligation/infringement number.
            <br />
            <br />
            Remember, the fine will continue to progress until you submit your form and receive a submission number.
          </p>
          <span className="vfH2">Send reminders of incomplete forms?</span>
          <div>We can send you a reminder for you to come back and submit your form.</div>
          <Field name="SaveOptions" component={TileRadioAccessible} tileData={TILE_DATA_NOTIFICATION_TYPE} orientationRow />
          {(values.SaveOptions === 'email' || values.SaveOptions === 'both') && (
            <Field name="saveEmail" title="Email Address" component={TextInput} isMandatory />
          )}
          {(values.SaveOptions === 'mobile' || values.SaveOptions === 'both') && (
            <Field name="saveMobile" title="Mobile Number" component={TextInput} isMandatory />
          )}
          <Button className={styles.modalLink} onClick={() => setNotifyHelp(true)} size="small">
            What will my notifications look like?
          </Button>
          {isNotifyHelp && <Modal close={() => closeNotifications()} show title={titleText} content={notificationInformation()} />}
        </>
      )}
    </div>
  );
}

export default ReviewStep4;
